var map = {
	"./favicons/apple-touch-icon-180x180.png": 6650,
	"./favicons/favicon.svg": 7686,
	"./favicons/icon-144x144.png": 369,
	"./favicons/icon-16x16.png": 5815,
	"./favicons/icon-192x192.png": 8409,
	"./favicons/icon-32x32.png": 7263,
	"./favicons/icon-48x48.png": 25,
	"./favicons/icon-512x512.png": 3705,
	"./favicons/icon-96x96.png": 7543,
	"./ofsted-good.svg": 2709,
	"./ofsted-outstanding.svg": 9174,
	"./pages/careers-advice/progress-careers-logo.png": 1666,
	"./pages/curriculum_overview/dtl-model.svg": 7277,
	"./pages/honours/badges.png": 8369,
	"./pages/honours/logo.png": 148,
	"./pages/honours/screenshot.png": 873,
	"./pages/the_elephant_group/the-elephant-group-logo.png": 7155,
	"./pages/uniform/trutex-preloved-left.svg": 6036,
	"./pages/uniform/trutex-preloved-right.svg": 4715,
	"./phone-free-school.svg": 96,
	"./streamline/duotone/programming/information.svg": 706,
	"./streamline/multicolor/business/fail-ice-cream.svg": 6958,
	"./streamline/multicolor/computer-programming/responsive-design.svg": 6631,
	"./streamline/multicolor/content/contract-book-pencil.svg": 1648,
	"./streamline/multicolor/content/document-approve.svg": 8993,
	"./streamline/multicolor/content/stamp-document-approve.svg": 3556,
	"./streamline/multicolor/content/view-eye.svg": 4845,
	"./streamline/multicolor/design/origami-paper-bird.svg": 6636,
	"./streamline/multicolor/ecology/ecosystem-half-globe.svg": 9157,
	"./streamline/multicolor/education/education-aid.svg": 7340,
	"./streamline/multicolor/education/education-reward.svg": 4279,
	"./streamline/multicolor/education/owl-laptop-study.svg": 6206,
	"./streamline/multicolor/education/teacher-shapes.svg": 2568,
	"./streamline/multicolor/mail/mail-letter.svg": 7542,
	"./streamline/multicolor/money/mobile-smartphone-credit-card-payment.svg": 6879,
	"./streamline/multicolor/rewards/star-rate.svg": 3054,
	"./streamline/multicolor/team-work/team-vote-hand-raise.svg": 2831,
	"./streamline/multicolor/travel/balloon.svg": 9448,
	"./streamline/multicolor/users/user.svg": 1286,
	"./streamline/multicolor/work/office-time.svg": 1144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;